// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DYjf","question":"styles_question__3_JPC","description":"styles_description__5hqZD"};